import { useErrorBoundary } from 'react-error-boundary';
import { isErrorWithMessage } from './constants/componentErrorFallback.constant';
import type { FC } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import styles from './ComponentErrorFallback.module.css';

const ComponentErrorFallback: FC<FallbackProps> = ({ error }) => {
  const { resetBoundary } = useErrorBoundary();
  const errorMessage = isErrorWithMessage(error) ? error.message : '';

  return (
    <div className={styles.errorContainerWrapper}>
      <div className={styles.errorContainer}>
        <p className={styles.bold}>Something went wrong:</p>
        {errorMessage && <p>{errorMessage}</p>}
        <p>
          <a className={styles.errorButton} onClick={resetBoundary} title='Try again' role='button'>
            Try again
          </a>
        </p>
      </div>
    </div>
  );
};

export default ComponentErrorFallback;
